// OneDrive:IgnoreCodeCoverage
import * as React from 'react';
import { WithItemCache, IItemCacheStateProps } from '../../../withItemCache/WithItemCache';
import {
  IDecorateWithSelectedItemsProps,
  IDecorateWithExactlyOneItemProps,
  withSelectedItems,
  withExactlyOneItem
} from '../../../decorators/selectors';
import { malwareDetectedControl, IMalwareDetectedWizardProps } from '../../../../controls/malwareDetectedControl';
import { IWizardActionStateProps, WizardAction } from '../../../wizardAction/WizardAction';
import { malwareDetectedFacet } from '../../../../facets/ItemFacets';
import { IActionInput, WithAction, IActionStateProps } from '../../../withAction/WithAction';
import { ActionBase } from '../../../action/Action';
import { getItemActionEngagement } from '../../../../models/telemetry/getItemEngagement';

export interface IItemShowMalwareDetectedActionProps {
  itemKey: string;
  malwareDetectedWizard: React.ComponentType<IMalwareDetectedWizardProps>;
  action?: IActionInput;
}

export class ItemShowMalwareDetectedAction extends React.PureComponent<IItemShowMalwareDetectedActionProps> {
  public render(): JSX.Element {
    const {
      itemKey,
      malwareDetectedWizard,
      action
    } = this.props;

    return (
      <WithItemCache>
        { ({ itemCache }: IItemCacheStateProps) => {
          const isMalwareDetected = itemCache.demandItemFacet(malwareDetectedFacet, itemKey);

          if (isMalwareDetected) {
            const controlHandler = itemCache.demandItemFacet(malwareDetectedControl, itemKey);

            const {
              malwareDetectedWizard: ItemMalwareDetectedWizard
            } = malwareDetectedControl.evaluate(controlHandler)(itemCache, {
              itemKey: itemKey,
              malwareDetectedWizard: malwareDetectedWizard
            });

            const FinalMalwareDetectedWizard = ItemMalwareDetectedWizard;

            return (
              <WizardAction
                { ...getItemActionEngagement(itemCache, {
                  itemKey,
                  engagement: {
                    name: 'MalwareDetected',
                    isIntentional: true
                  }
                }) }
              >
                { (wizardProps: IWizardActionStateProps) => {
                  return (
                    <FinalMalwareDetectedWizard
                      { ...wizardProps }
                      itemKey={ itemKey }
                    />
                  );
                } }
              </WizardAction>
            );
          }

          return (
            <WithAction
              action={ action }
            >
              { ({ isAvailable, isToggled, execute }: IActionStateProps) => {
                return (
                  <ActionBase isAvailable={ isAvailable } isToggled={ isToggled } onExecute={ execute } />
                );
              } }
            </WithAction>
          );
        } }
      </WithItemCache>
    );
  }
}

export type IShowMalwareDetectedActionProps =
  IDecorateWithSelectedItemsProps<IDecorateWithExactlyOneItemProps<IItemShowMalwareDetectedActionProps>>;

export const ShowMalwareDetectedAction: React.ComponentType<IShowMalwareDetectedActionProps> =
  withSelectedItems()(withExactlyOneItem()(ItemShowMalwareDetectedAction));
